import { ref } from 'vue'
import { toOptions } from '../shared/fns'

export const module = ref()

export const modules = ['signaling', 'training', 'energy']

export const moduleOptions = toOptions(modules)
